import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../environments/environment';
import { Bisac } from '../models/Bisac';

@Injectable()
export class BisacService {

  selectedCodice: string;

  get selected(): string {
    return this.selectedCodice;
  }
  set selected(codice: string) {
    this.selectedCodice = codice;
  }

  constructor(private http: Http) { }

  search(q): Observable<any> {
    return this.http.post(environment.server.url + '/bisac/search', { q: q })
      .map(response => response.json())
  }
}



// WEBPACK FOOTER //
// ./src/app/services/bisac.service.ts